<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Vendas
            <el-button icon="fa fa-download"
              :loading="btnLoading"
              style="font-size: 1em; float: right"
              @click="report()"
              circle></el-button>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; margin-right: 15px; float: right;"></el-button>
            <!-- <a
              style="font-size: 1em"
              class="btn btn-info btn-link btn-xs"
              @click="report()"
            >
              <i class="fa fa-file-excel-o"  style="font-size: 1em" ></i>
            </a> -->
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
            <!-- <div class="col-sm-12">
              <label class="col-sm-6">Cliente</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="client"
              >
                <el-option
                  v-for="option in clientName"
                  class="select-danger"
                  :value="option.id"
                  :label="option.first_name + ' ' + option.last_name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div> -->
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Status</label>
                <el-autocomplete
                  class="select-default col-sm-12"
                  v-model="statusSale"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="Comece a digitar para pesquisar"
                  @select="handleSelect"
                ></el-autocomplete>
            </div>
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Maquina</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="vendMachine"
              >
                <el-option
                  v-for="maq in machine"
                  class="select-danger"
                  :value="maq.id"
                  :label="maq.location"
                  :key="maq.id"
                ></el-option>
              </el-select>
            </div>
            <div class="col-sm-11" style="margin-top: 10px">
              <label class="col-sm-6">Periodo</label>
              <el-date-picker
                style="margin-left: 15px"
                v-model="date_init"
                type="daterange"
                format="dd/MM/yyyy"
                align="right"
                unlink-panels
                range-separator="a"
                start-placeholder="Data de início"
                end-placeholder="Data final">
              </el-date-picker>
            </div>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData"  @sort-change="sorting" v-loading="loading">
            <el-table-column label="VM" property="vm" min-width="150" sortable='custom' >
              <template slot-scope="props">
                <span v-if="props.row.vm">{{ `${props.row.vm.location}` }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="ID do Mercado Pago" property="mp_uid" width="180"></el-table-column> -->
            <el-table-column label="Itens" property="sales_items" width="160"/>
            <el-table-column label="Valor unitário (R$)" property="unit_price" style="align-text: center" width="165" sortable='custom'/>
            <el-table-column label="Valor total (R$)" property="total" width="120" />
            <el-table-column label="Status" property="status" width="110" sortable='custom'/>
            <el-table-column label="Estornar" width="80">
              <template slot-scope="scope" >
              <el-button v-if="scope.row.status === 'approved'" 
                  type="text" @click="doRefund(scope.row)">$</el-button>
              </template>
            </el-table-column>
            <el-table-column v-if="$store.state.company.company.payment_methods === 'MP' || showItem" label="M.Pago" 
                            property="mp_uid" min-width="115"/>
            <el-table-column label="Cliente" property="customer" width="120" sortable='custom'>
              <template slot-scope="props">
                <span
                  v-if="props.row.customer"
                >{{ `${props.row.customer.first_name} ${props.row.customer.last_name}` }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Comprado em" property="sale_datetime" width="160" sortable='custom'/>
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next, total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { 
  Table, 
  TableColumn, 
  Button,
  Dialog, 
  Select, 
  Option, 
  Pagination, 
  Loading, 
  Autocomplete, 
  DatePicker,
  TimeSelect, } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Autocomplete.name]: Autocomplete,
    
  },
  data() {
    return {
      filtro: false,
      ttt: '2019-11-21T02:00:00.000z',
      loading: true,
      btnLoading: false,
      machines: [],
      customers: [],
      sales: [],
      previousPage: "",
      nextPage: "",
      statusSale: '',
      client: [],
      vendMachine: [],
      date_init: [],
      vms: [],
      totalResults: 30,
      links: [],
      state: '',
      timeout:  500,
      pesquisa: '',
      page: 1,
      sord: '',
      pageSize: 10,
      order: false,
    };
  },
  created() {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted() {
    this.getListCompany()
  },
  computed: {
    tableData() {
      const sales = this.sales;
      const customers = this.customers;
      const machines = this.machines;
      const populated = sales.map(v => {
        let vm, customer, updated, total, unit_price, sale_datetime
        if (v.vm) {
          vm = machines.find(e => e.id == v.vm);
        }
        if (v.sales_items && v.unit_price) {
          total = v.sales_items.substr(0, v.sales_items.indexOf(' '))
          total = Number(total) * v.unit_price
          total = total.toFixed(2)
        }
        if (v.unit_price) {
          unit_price = v.unit_price.toFixed(2)
        }
        if (v.customer) {
          customer = customers.find(e => e.id == v.customer);
        }
        // if (v.updated) {
        //   const d = new Date(v.updated);
        //   updated = d.toLocaleString("pt-BR");
        // }
        if (v.sale_datetime) {
          const y = new Date(v.sale_datetime);
          sale_datetime = y.toLocaleString("pt-BR");
        } else {
          if (v.updated) {
            const d = new Date(v.updated);
            sale_datetime = d.toLocaleString("pt-BR");
          }
        }
        return { ...v, vm, customer, sale_datetime, total, unit_price };
      });
      console.log('pop', populated)
      return populated;
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    machine() {
      return this.machines;
    },
    clientName() {
      var seenNumber = {};

      var fil = this.$store.state.customers.customers.filter(function(
        currentObject
      ) {
        if (currentObject.email in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.email] = true;
          return true;
        }
      });
      return fil;
    },
    saleStatus() {
      var seenNumber = {};

      var fil = this.$store.state.sales.sales.results.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    }
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      // if (x.prop === 'sale_datetime') {
      //   x.prop = 'updated'
      // }
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/sales/sale/${row.id}`);
    },
    getData(ciaID) {
      this.loading = true
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.$store.dispatch("sales/listSort", {sort: '?page_size=' + this.pageSize
            + '&page=' + this.page + '&ordering=' + this.sord
            + '&company=' + ciaID + this.pesquisa})
        .then(() => this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + ciaID}).then(data =>{
          this.machines = data
          this.$store.dispatch('lockers/listSort', {sort: '?page_size=300'  + '&company=' + ciaID}).then(resp => {
            for (let index = 0; index < resp.length; index++) {
              this.machines.push(resp[index])
            }
          console.log('machines', this.machines)
          })
        }))
        .then(() => {
          this.$store.dispatch("customers/list")
          .then(() => {
            this.sales = this.$store.state.sales.sales.results;
            this.totalResults = this.$store.state.sales.page.count
            // this.machines = this.$store.state.machines.machines;
            this.customers = this.$store.state.customers.customers;
            this.loading = false
          })
        })
        .catch(err => console.log(err));
    },
    filtragem() {
      this.loading = true
      var date = []
      this.pesquisa = ''


      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + "&company=" + ciaID
      }

      // if (this.client) {
      //   this.pesquisa = this.pesquisa + "&customer=" + this.client
      // }
      if (this.statusSale) {
        this.pesquisa = this.pesquisa + "&status=" + this.statusSale
      }
      if (this.vendMachine) {
        this.pesquisa = this.pesquisa + "&vm=" + this.vendMachine
      }
      if (this.date_init.length > 0) {
        date[0] = new Date(this.date_init[0]).toISOString()
        date[1] = new Date(this.date_init[1]).toISOString()
        date[1] = date[1].slice(0,11) + '23%3A55%3A00.000Z'
        date[0] = date[0].slice(0,11) + '01%3A00%3A00.000Z'
        this.pesquisa = this.pesquisa + '&sale_datetime__range=' + date[0] + '%2C' + date[1]
        console.log('pesq', this.pesquisa)
      }
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }

      this.filtro = false;
    },
    clearFiltro() {
      this.client = "";
      this.statusSale = "";
      this.vendMachine = "";
      this.pesquisa = ''
      this.date_init = []
      this.page = 1
      const ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.filtro = false;
    },
    report() {
      if (this.totalResults > 3000) {
        swal.fire({
          title: "Excesso de Informação",
          text: 'Há muitos dados, favor use o filtro para diminuir a quantidade de informações.' +  
          ' O limite é de 3 mil resultados.' +
          ' No momento há ' +  this.totalResults + ' resultados',
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        }).then(()=>{
        })  
      } else {
        this.btnLoading = true
        if (this.pesquisa == '') {
          const ciaID = localStorage.getItem('imachCiaID')
          if (ciaID) {
            this.pesquisa = this.pesquisa + "?company=" + ciaID
          }
        }
        this.pesquisa = this.pesquisa.replace('&','?')
        this.$store.dispatch('general/excelSell', {search: this.pesquisa}).then(data => {
          this.btnLoading = data
        })
      }
    },
    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("sales/listSort", {sort: '?status__icontains=' + queryString}).then(data => {
        var x = data.results.map(v => {
          let value, link
          if (v.status) {
            value = v.status
          }
          link = value
          return {...v, value, link}
          
        })
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results
        
        results = queryString ? links.filter(this.createFilter(queryString)) : links;
      
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.statusSale = item.status
      console.log('selec', item);
    },
    redux(x) {
      var seenNumber = {};

      var fil = x.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    },
    doRefund (data) {
      // /interface/v1/sale/<id_da_venda>/refund_sale/ -->
      console.log('data',data)
      var titulo
      var texto
      if (data.mp_uid != null) {
        titulo = "Tem certeza?"
        texto = `Você está prestes a estornar essa venda inteira. Esse processo é irreversível!`
      } else {
        titulo = "Não é possivel estornar o valor desta operação, apenas efetuar seu registro."
        texto = `O item desta operação retornará para o estoque após a confirmação.`
      }

      swal.fire({
        title: titulo,
        text: texto,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, estorne!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("sales/refund", {id: data.id}).then(res => {
            console.log('reso', res)
            if (res.status === 200) {
              swal.fire({
                title: "Pronto!",
                text: `Venda estornada`,
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false
              })
              const ciaID = localStorage.getItem('imachCiaID')
              if (ciaID) {
                this.getData(ciaID)
              } else {
                this.getData()
              }
            } else {
              swal.fire({
                title: "Ops!",
                text: `Venda não estornada devido ao um erro.`,
                icon: "error",
                confirmButtonClass: "btn btn-info btn-fill",
                buttonsStyling: false
              });
            }
          }).catch(err => {
            console.log('catch', err)
          })
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `Venda não estornada`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    } // fim
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
#linha {
  width: 100%;
  border-bottom: 1px solid #c5c0c0;
}
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
